/**
 * "preparação 2", "preparações 1 e 3", "preparações 1, 2 e 4": which
 * preparations a finding covers, when an orçamento holds more than one person
 * (#342). Undefined when the finding does not say, which is every orçamento
 * for one patient and one prescriber.
 */
export function preparationsLabel(evidence: Readonly<Record<string, unknown>>): string | undefined {
  const raw = evidence['preparations']
  if (!Array.isArray(raw)) return undefined
  const numbers = raw.filter((n): n is number => typeof n === 'number')
  if (numbers.length === 0) return undefined
  if (numbers.length === 1) return `preparação ${numbers[0]}`
  const last = numbers[numbers.length - 1]
  return `preparações ${numbers.slice(0, -1).join(', ')} e ${last}`
}
